/** @format */

import { config } from "@/Helper/config";
import axios from "axios";

const getAllUtilityData = () => {
  //  try {
  //     axios.get(`${config.strapiAPi}/api/sitemap.xml`)
  //  } catch (error) {
  //    console.log("error")
  //  }
  return axios.get(`${config.strapiAPi}/api/utility?populate=*`);
};

const getAllSponsorsImage = () => {
  return axios.get(`${config.strapiAPi}/api/sponsor?populate=sponsor_image`);
};

const getAllCustomerVoiceDetails = () => {
  return axios.get(`${config.strapiAPi}/api/customers-voices?populate=*`);
};
const getAllFAQ = () => {
  return axios.get(`${config.strapiAPi}/api/faqs`);
};
const getFAQByCategory = ({ page }) => {
  return axios.get(`${config.strapiAPi}/api/getfaq/${page}`);
};

const getRecentBlog = (currentPage = null) => {
  const pagination =
    currentPage && currentPage >= 1
      ? `&pagination[page]=${currentPage}&pagination[pageSize]=12`
      : null;
  return axios.get(
    `${config.strapiAPi}/api/blogs?populate=image&sort=publishedAt:desc${
      pagination ?? ""
    }`
  );
};

const getRecentBlogWithkeySearch = ({ keyword = "-" }) => {
  return axios.get(`${config.strapiAPi}/api/bloggers/${keyword ?? "-"}`);
};

const getBlogDetailsById = ({ id }) => {
  return axios.get(`${config.strapiAPi}/api/blogger/${id}`, {
    rejectUnauthorized: false,
    strictSSL: false,
  });
};

const getBlogDetailById = ({ id }) => {
  return axios.get(`${config.strapiAPi}/api/blogs/${id}`);
};

const postContactUsDetails = ({ data }) => {
  return axios.post(`${config.strapiAPi}/api/contact-uses`, { data });
};

const postContactUsDetailsFooter = ({ data }) => {
  return axios.post(`${config.strapiAPi}/api/contact-us-footers`, { data });
};
const sendThankyouMail = ({ data }) => {
  return axios.post(`${config.strapiAPi}/api/email`, data);
};

const testimonials = () => { 
  return axios.get(`${config.strapiAPi}/api/testimonials`);
};

const getPillarPageData = () => {
  return axios.get(`${config.strapiAPi}/api/digital-signage`);
};

const getOpeningJob = () => {
  return axios.get(`${config.strapiAPi}/api/job-listings`); 
};

const getDesklessPillarPageData = () => {
  return axios.get(`${config.strapiAPi}/api/bb-pillar-page`);
};


export const postcareersDetails = async (formData) => {
  try {
    // Debugging FormData Entries
    for (let pair of formData.entries()) {
      if (pair[1] instanceof File) {
        console.log(`📄 File Upload: ${pair[0]} -> ${pair[1].name} (${pair[1].size} bytes)`);
      } else {
        console.log(`🔹 Field: ${pair[0]} -> ${pair[1]}`);
      }
    }

    // API Request
    const response = await axios.post(`${config.strapiAPi}/api/careers`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    console.log("✅ API Response:", response.data);
    return response;
  } catch (error) {
    console.error("❌ API Error:", error.response?.data || error.message);
    throw error;
  }
};

const getJobDetails = (jobSlug) => {
  return axios.get(`${config.strapiAPi}/api/job-listings?filters[url_index][$eq]=${jobSlug}&populate=*`);
};


const sendThankyouMailCareers = ({ data }) => {
  return axios.post(`${config.strapiAPi}/api/emailjob`, data);
};

const sendThankyouMailReadyFlex = ({ data }) => {
  return axios.post(`${config.strapiAPi}/api/emailreadyflex`, data);
};

export const apiService = {
  getAllUtilityData,
  getAllSponsorsImage,
  getAllCustomerVoiceDetails,
  getAllFAQ,
  getRecentBlog,
  getBlogDetailsById,
  postContactUsDetails,
  sendThankyouMail,
  getFAQByCategory,
  getBlogDetailById,
  getPillarPageData,
  getDesklessPillarPageData,
  getRecentBlogWithkeySearch,
  postContactUsDetailsFooter,
  testimonials,
  postcareersDetails,
  getOpeningJob,
  getJobDetails,
  sendThankyouMailCareers,
  sendThankyouMailReadyFlex
};
